import { checkBypassMode } from 'marketing/lib/lib'
import { createSelector } from 'reselect'

export const isPaidSessionSelector = createSelector(
  (state: App.State) => state.utm,
  (utm) => checkBypassMode(utm.bp),
)
